export default __webpack_public_path__ + "static/SCUBA_Flippers-211ea3d6b2994c30c329dcfbe1512b82.png";